// extracted by mini-css-extract-plugin
module.exports = {"root":"AuctionCountdown_root__Xmb_8"};